import { useRef } from 'react';
import { getDeviceTypeFromUserAgentString } from './getDeviceTypeFromUserAgentString';
import type { TabletOrMobileOrDesktop } from './types';
export const useDeviceType = (): TabletOrMobileOrDesktop => {
  const isClient = typeof window !== 'undefined';
  const deviceType = useRef(isClient ? getDeviceTypeFromUserAgentString(window.navigator.userAgent) : 'mobile');
  return deviceType.current;
};